import { Perfil } from './../perfil/perfil.model';
import { BaseEntityAuditada } from '../models/base-entity-auditada.model';
import { Usuario } from '../usuario/usuario.model';
import { FonteDados } from './../fonte-dados/fonte-dados.model';
import { OrgaoJustica } from '../orgao-justica/orgao-justica.model';
import { OrgaoJulgador } from '../processo-distribuicao/processo-distribuicao.model';
import { LimiteNivelSigilo } from '../models/limite-nivel-sigilo.enum';
import { OrgaoJulgadorColegiadoLocal } from '../orgao-julgador-colegiado-local/orgao-julgador-colegiado-local.model';

export interface UsuarioPermissao extends BaseEntityAuditada {
  id?: number;
  usuario?: Usuario;
  vigente?: boolean;
  inicio?: Date;
  fim?: Date;
  abrangencia?: PermissaoAbrangencia;
  orgaoJustica?: OrgaoJustica;
  fonteDados?: FonteDados;
  orgaoJulgadorColegiado?: OrgaoJulgadorColegiadoLocal;
  orgaoJulgador?: OrgaoJulgador;
  limiteNivelSigilo?: LimiteNivelSigilo;
  origem?: PermissaoOrigem;
  perfil?: Perfil;
}

export enum PermissaoAbrangencia {
  NACIONAL = 'NACIONAL',
  ORGAO_JUSTICA = 'ORGAO_JUSTICA',
  FONTE_DADOS = 'FONTE_DADOS',
  ORGAO_JULGADOR_COLEGIADO = 'ORGAO_JULGADOR_COLEGIADO',
  ORGAO_JULGADOR = 'ORGAO_JULGADOR',
}

export enum PermissaoOrigem {
  NATIVO = 'NATIVO',
  CORPORATIVO = 'CORPORATIVO',
}
